/* Mayalice — animations & dynamic sections */

(function () {
  'use strict';

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // --------------------------------------------------------------------------
  // Header · hide on scroll down / reveal on scroll up
  // --------------------------------------------------------------------------

  // Tag du header en mode "scrolled" (utilisé par le CSS pour le mode transparent
  // flottant). Indépendant de headerAutoHide pour fonctionner même en reduced-motion.
  (function headerScrollState() {
    const headerSection = document.querySelector('.header-section');
    if (!headerSection) return;
    let rafId = 0;
    const apply = () => {
      rafId = 0;
      if (window.scrollY > 8) headerSection.setAttribute('data-ma-scrolled', 'true');
      else headerSection.removeAttribute('data-ma-scrolled');
    };
    apply();
    window.addEventListener('scroll', () => {
      if (!rafId) rafId = requestAnimationFrame(apply);
    }, { passive: true });
  })();

  // Header en sticky permanent partout (mode Atelier `enable_sticky_header = always`).
  // L'auto-hide précédent a été retiré — le header reste visible tout le temps,
  // quel que soit la page.

  // --------------------------------------------------------------------------
  // Header : laisser Atelier gérer le menu_style natif (horizontal sur desktop,
  // drawer sur mobile). Le forçage drawer global a été retiré au profit du
  // header horizontal style Astrid & Miyu.
  // --------------------------------------------------------------------------

  // --------------------------------------------------------------------------
  // Panneau de recherche Mayalice
  // - Remplace la pill <search-button> Atelier par un VRAI input éditable
  //   visible en permanence dans le header (pas d'overlay barre géante)
  // - Au focus de l'input pill → ouvre le dropdown (collections + suggestions)
  // - Recherches récentes dans localStorage (max 6, dédoublonnées)
  // - Submit → /search?q=… (form natif)
  // --------------------------------------------------------------------------
  (function mayaliceSearchPanel() {
    const panel = document.querySelector('[data-ma-search]');
    if (!panel) return;
    const overlay = panel.querySelector('[data-ma-search-overlay]');
    const recentGroup = panel.querySelector('[data-ma-search-recent-group]');
    const recentList = panel.querySelector('[data-ma-search-recent]');
    const clearBtn = panel.querySelector('[data-ma-search-clear]');
    // Placeholder initial pour le pill input (lu depuis la section ou défaut)
    const PILL_PLACEHOLDER = (document.querySelector('[data-ma-search-placeholder]') || {}).textContent
      || 'Rechercher un bijou, une collection…';
    // Ces refs seront peuplées après transformation de la pill
    let pillInputs = [];

    const STORAGE_KEY = 'mayalice.recent_searches';
    const RECENT_MAX = 6;

    const readRecent = () => {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return [];
        const arr = JSON.parse(raw);
        return Array.isArray(arr) ? arr.filter((x) => typeof x === 'string').slice(0, RECENT_MAX) : [];
      } catch (e) { return []; }
    };

    const writeRecent = (arr) => {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(arr.slice(0, RECENT_MAX))); }
      catch (e) { /* quota or private mode — silent */ }
    };

    const renderRecent = () => {
      const items = readRecent();
      if (!items.length) {
        if (recentGroup) recentGroup.setAttribute('hidden', '');
        return;
      }
      if (recentGroup) recentGroup.removeAttribute('hidden');
      if (!recentList) return;
      recentList.innerHTML = items.map((t) => {
        const safe = String(t).replace(/[<>&"]/g, (c) => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' }[c]));
        return `<li><a href="/search?q=${encodeURIComponent(t)}" data-ma-search-suggestion="${safe}">${safe}</a></li>`;
      }).join('');
    };

    const pushRecent = (term) => {
      const t = String(term || '').trim();
      if (!t) return;
      const items = readRecent().filter((x) => x.toLowerCase() !== t.toLowerCase());
      items.unshift(t);
      writeRecent(items);
      renderRecent();
    };

    const computeOffset = () => {
      // Bottom de la dernière section du groupe header (annonce + nav)
      // pour que le panneau s'ouvre PILE en dessous, sans masquer la barre
      // d'annonce. On exclut nous-mêmes du calcul.
      const sections = Array.from(document.querySelectorAll('.shopify-section-group-header-group'))
        .filter((el) => !el.classList.contains('mayalice-search-section'));
      let maxBottom = 0;
      sections.forEach((s) => {
        const r = s.getBoundingClientRect();
        if (r.height > 0) maxBottom = Math.max(maxBottom, r.bottom);
      });
      if (maxBottom <= 0) {
        // Fallback : header-section seul
        const hs = document.querySelector('.header-section');
        if (hs) maxBottom = hs.getBoundingClientRect().bottom;
      }
      return Math.max(60, Math.round(maxBottom));
    };

    // Input mobile vivant DANS le panel (flux normal, pas position:fixed) —
    // évite les bugs iOS Safari où un input focusé dans un parent fixed peut
    // se rendre hors de la container visible quand le clavier ouvre.
    const mobileInput = panel.querySelector('[data-ma-search-panel-input]');
    const mobileForm = panel.querySelector('[data-ma-search-panel-form]');
    const isMobileViewport = () => window.matchMedia('(max-width: 749px)').matches;

    const open = (opts) => {
      panel.style.setProperty('--ma-search-offset', computeOffset() + 'px');
      panel.removeAttribute('hidden');
      panel.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ma-search-open');
      renderRecent();
      // Sur mobile, focus l'input du panel (statique, dans le flux du document)
      // immédiatement pour conserver le user gesture et ouvrir le clavier iOS.
      if (opts && opts.focusMobile && mobileInput && isMobileViewport()) {
        try { mobileInput.focus({ preventScroll: true }); }
        catch (err) { try { mobileInput.focus(); } catch (err2) { /* noop */ } }
      }
    };

    const close = () => {
      panel.setAttribute('hidden', '');
      panel.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ma-search-open');
      // Blur les inputs (header pill + panel mobile) pour fermer le clavier
      pillInputs.forEach((el) => { if (document.activeElement === el) el.blur(); });
      if (mobileInput && document.activeElement === mobileInput) mobileInput.blur();
    };

    if (mobileForm) {
      mobileForm.addEventListener('submit', () => {
        const v = mobileInput ? mobileInput.value.trim() : '';
        if (v) pushRecent(v);
      });
    }

    // Transforme la pill <search-button> native d'Atelier en vrai formulaire
    // input. C'est cet input qui est utilisé pour taper la recherche — le
    // panel ne contient plus que les suggestions/collections.
    const SEARCH_ICON_SVG = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="9" r="6"/><path d="m17 17-3.5-3.5"/></svg>';
    const CLEAR_ICON_SVG = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" aria-hidden="true"><path d="M5 5 L15 15 M15 5 L5 15"/></svg>';

    const upgradePill = (host) => {
      if (!host || host.dataset.maSearchPillReady === '1') return;
      // Évite double init si Atelier re-render
      host.dataset.maSearchPillReady = '1';
      // Neutralise le bouton/dialog natif Atelier
      host.querySelectorAll('button[on\\:click]').forEach((b) => b.removeAttribute('on:click'));
      host.innerHTML = `
        <form class="ma-search-pill" action="/search" method="get" role="search" data-ma-search-pill-form>
          <input type="hidden" name="options[prefix]" value="last">
          <span class="ma-search-pill__icon">${SEARCH_ICON_SVG}</span>
          <input
            type="search"
            name="q"
            class="ma-search-pill__input"
            placeholder="${PILL_PLACEHOLDER.replace(/"/g, '&quot;')}"
            aria-label="Rechercher"
            autocomplete="off"
            data-ma-search-pill-input
          >
          <button type="button" class="ma-search-pill__clear" data-ma-search-pill-clear aria-label="Effacer la recherche" hidden>${CLEAR_ICON_SVG}</button>
        </form>
      `;
      const formEl = host.querySelector('[data-ma-search-pill-form]');
      const inputEl = host.querySelector('[data-ma-search-pill-input]');
      const clearEl = host.querySelector('[data-ma-search-pill-clear]');
      pillInputs.push(inputEl);

      const refreshClear = () => {
        if (!clearEl) return;
        if (inputEl.value.length > 0) clearEl.removeAttribute('hidden');
        else clearEl.setAttribute('hidden', '');
      };

      inputEl.addEventListener('focus', () => { open(); });
      inputEl.addEventListener('click', () => { open(); });
      inputEl.addEventListener('input', refreshClear);
      // Mobile : la pill du header est uniquement une icône loupe (l'input
      // dedans est display:none). Le tap ouvre le panel + focus l'input
      // STATIQUE du panel (mobileInput) synchronement pour iOS keyboard.
      // Desktop : focus l'input pill comme avant.
      host.addEventListener('pointerdown', (e) => {
        if (e.target === inputEl) return;
        if (isMobileViewport()) {
          open({ focusMobile: true });
        } else {
          open();
          try { inputEl.focus({ preventScroll: true }); } catch (err) { /* noop */ }
        }
      });
      host.addEventListener('click', (e) => {
        if (e.target === inputEl) return;
        if (panel.hasAttribute('hidden')) {
          if (isMobileViewport()) {
            open({ focusMobile: true });
          } else {
            open();
            try { inputEl.focus({ preventScroll: true }); } catch (err) { /* noop */ }
          }
        }
      });
      formEl.addEventListener('submit', () => {
        const v = inputEl.value.trim();
        if (v) pushRecent(v);
      });
      clearEl.addEventListener('click', () => {
        inputEl.value = '';
        refreshClear();
        inputEl.focus();
      });
      refreshClear();
    };

    const upgradeAllPills = () => {
      document.querySelectorAll('search-button.search-action, .search-action').forEach((host) => {
        // Évite de réécrire si déjà upgrade
        if (host.dataset.maSearchPillReady === '1') return;
        upgradePill(host);
      });
    };

    upgradeAllPills();
    // Re-hook si Atelier re-render (MutationObserver sur le body)
    new MutationObserver(upgradeAllPills).observe(document.body, { childList: true, subtree: true });

    // Empêche l'ouverture du modal Atelier (si raccourci clavier ou code natif
    // tente showDialog).
    const nativeModal = document.querySelector('#search-modal');
    if (nativeModal) {
      const dlg = nativeModal.querySelector('dialog');
      if (dlg) {
        dlg.showModal = function () { /* swallowed */ };
        dlg.show = function () { /* swallowed */ };
        new MutationObserver(() => {
          if (dlg.open) {
            try { dlg.close(); } catch (err) { /* noop */ }
            // Si jamais Atelier l'ouvre, on focus la pill à la place
            const firstPill = pillInputs[0];
            if (firstPill) firstPill.focus();
          }
        }).observe(dlg, { attributes: true, attributeFilter: ['open'] });
      }
      nativeModal.style.display = 'none';
    }

    if (overlay) overlay.addEventListener('click', close);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !panel.hasAttribute('hidden')) close();
    });

    // Ferme le dropdown si on clique en dehors de la pill et du panel
    document.addEventListener('click', (e) => {
      if (panel.hasAttribute('hidden')) return;
      const inPill = e.target.closest('.ma-search-pill, search-button.search-action, .search-action');
      const inPanel = panel.contains(e.target);
      if (!inPill && !inPanel) close();
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        try { localStorage.removeItem(STORAGE_KEY); } catch (err) { /* noop */ }
        renderRecent();
      });
    }

    // Suggestions populaires : track aussi dans recent au clic
    panel.addEventListener('click', (e) => {
      const link = e.target.closest('[data-ma-search-suggestion]');
      if (!link) return;
      pushRecent(link.dataset.maSearchSuggestion);
      // navigation native (pas de preventDefault)
    });

    // Recompute offset au resize / scroll header
    window.addEventListener('resize', () => {
      panel.style.setProperty('--ma-search-offset', computeOffset() + 'px');
    });
  })();

  // --------------------------------------------------------------------------
  // Reveal on scroll
  // --------------------------------------------------------------------------

  const revealTargets = document.querySelectorAll('[data-ma-reveal]');

  if (revealTargets.length && !prefersReducedMotion && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.setAttribute('data-ma-reveal', 'in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );
    revealTargets.forEach((el) => io.observe(el));
  } else {
    revealTargets.forEach((el) => el.setAttribute('data-ma-reveal', 'in'));
  }

  // --------------------------------------------------------------------------
  // Hero · mark as loaded once the main image is ready
  // --------------------------------------------------------------------------

  document.querySelectorAll('.mayalice-hero').forEach((hero) => {
    const media = hero.querySelector('img, video');
    if (!media) {
      hero.dataset.loaded = 'true';
      return;
    }
    if (media.complete || media.readyState >= 3) {
      requestAnimationFrame(() => (hero.dataset.loaded = 'true'));
    } else {
      media.addEventListener(
        'load',
        () => requestAnimationFrame(() => (hero.dataset.loaded = 'true')),
        { once: true }
      );
      media.addEventListener(
        'loadeddata',
        () => requestAnimationFrame(() => (hero.dataset.loaded = 'true')),
        { once: true }
      );
    }
  });

  // --------------------------------------------------------------------------
  // Announcement bar · rotate slides every N seconds
  // --------------------------------------------------------------------------

  document.querySelectorAll('.mayalice-announcement[data-autoplay="true"]').forEach((bar) => {
    const slides = bar.querySelectorAll('.mayalice-announcement__slide');
    if (slides.length <= 1) return;
    const interval = parseInt(bar.dataset.interval, 10) || 5000;
    let i = 0;
    setInterval(() => {
      slides[i].classList.remove('mayalice-announcement__slide--active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('mayalice-announcement__slide--active');
    }, interval);
  });

  // --------------------------------------------------------------------------
  // Instagram feed · fetch from configured endpoint (Cloudflare Worker)
  // Falls back to static images pre-rendered server-side.
  // --------------------------------------------------------------------------

  document.querySelectorAll('.mayalice-instagram[data-endpoint]').forEach(async (section) => {
    const endpoint = section.dataset.endpoint;
    const grid = section.querySelector('.mayalice-instagram__grid');
    if (!endpoint || !grid) return;

    const limit = parseInt(section.dataset.limit, 10) || 3;

    try {
      const res = await fetch(endpoint, { headers: { Accept: 'application/json' } });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const payload = await res.json();
      const posts = (payload.data || payload.posts || payload).slice(0, limit);
      if (!Array.isArray(posts) || !posts.length) return;

      const html = posts
        .map((p) => {
          const img = p.media_type === 'VIDEO' ? p.thumbnail_url || p.media_url : p.media_url;
          const href = p.permalink || `https://www.instagram.com/${section.dataset.handle || ''}/`;
          return `
            <a class="mayalice-instagram__tile" href="${href}" target="_blank" rel="noopener noreferrer" aria-label="Post Instagram">
              <img src="${img}" alt="" loading="lazy" />
              <span class="mayalice-instagram__icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                  <rect x="3" y="3" width="18" height="18" rx="4"/>
                  <circle cx="12" cy="12" r="4"/>
                  <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
                </svg>
              </span>
            </a>
          `;
        })
        .join('');
      grid.innerHTML = html;
    } catch (err) {
      /* garde le rendu serveur fallback */
      console.debug('[mayalice] Instagram feed unavailable, using fallback.', err);
    }
  });

  // --------------------------------------------------------------------------
  // Onglets + carousel horizontal avec progress bar
  // --------------------------------------------------------------------------

  document.querySelectorAll('[data-ma-tabs]').forEach((section) => {
    const tabs = section.querySelectorAll('[data-ma-tab]');
    const panels = section.querySelectorAll('[data-ma-panel]');
    if (!tabs.length || !panels.length) return;

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.maTab;
        tabs.forEach((t) => {
          const active = t.dataset.maTab === target;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach((p) => {
          const active = p.dataset.maPanel === target;
          p.classList.toggle('is-active', active);
          if (active) p.removeAttribute('hidden');
          else p.setAttribute('hidden', '');
        });
      });
    });
  });

  // Progress bar sur carrousels horizontaux
  document.querySelectorAll('[data-ma-carousel]').forEach((carousel) => {
    const progress = carousel
      .closest('[data-ma-panel], .mayalice-tabs__panel')
      ?.querySelector('[data-ma-progress] .mayalice-tabs__progress-bar');
    if (!progress) return;

    let rafId = 0;

    const update = () => {
      rafId = 0;
      const max = carousel.scrollWidth - carousel.clientWidth;
      if (max <= 0) {
        progress.style.width = '100%';
        progress.style.left = '0%';
        return;
      }
      const ratio = Math.max(0, Math.min(1, carousel.scrollLeft / max));
      const visibleRatio = carousel.clientWidth / carousel.scrollWidth;
      const widthPercent = Math.max(15, Math.min(100, visibleRatio * 100));
      const maxLeft = 100 - widthPercent;
      progress.style.width = `${widthPercent}%`;
      progress.style.left = `${ratio * maxLeft}%`;
    };

    carousel.addEventListener(
      'scroll',
      () => {
        if (!rafId) rafId = requestAnimationFrame(update);
      },
      { passive: true }
    );

    window.addEventListener('resize', update);

    // Recompute when tab is shown (hidden removed)
    const observer = new MutationObserver(update);
    const panel = carousel.closest('[data-ma-panel], .mayalice-tabs__panel');
    if (panel) observer.observe(panel, { attributes: true, attributeFilter: ['hidden'] });

    update();
  });

  // --------------------------------------------------------------------------
  // Rassurance · dots pagination (mobile carousel)
  // --------------------------------------------------------------------------

  document.querySelectorAll('.mayalice-rassurance').forEach((section) => {
    const grid = section.querySelector('.mayalice-rassurance__grid');
    const dots = section.querySelectorAll('.mayalice-rassurance__dot');
    if (!grid || !dots.length) return;

    const items = grid.querySelectorAll('.mayalice-rassurance__item');

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        const target = items[i];
        if (!target) return;
        const left = target.offsetLeft - (grid.clientWidth - target.clientWidth) / 2;
        grid.scrollTo({ left, behavior: 'smooth' });
      });
    });

    let rafId = 0;
    grid.addEventListener(
      'scroll',
      () => {
        if (rafId) return;
        rafId = requestAnimationFrame(() => {
          rafId = 0;
          const center = grid.scrollLeft + grid.clientWidth / 2;
          let closest = 0;
          let minDist = Infinity;
          items.forEach((item, i) => {
            const itemCenter = item.offsetLeft + item.clientWidth / 2;
            const d = Math.abs(itemCenter - center);
            if (d < minDist) {
              minDist = d;
              closest = i;
            }
          });
          dots.forEach((dot, i) => dot.classList.toggle('is-active', i === closest));
        });
      },
      { passive: true }
    );
  });

  // --------------------------------------------------------------------------
  // Footer accordéon · open sur desktop, closed par défaut sur mobile
  // --------------------------------------------------------------------------

  (function syncFooterAccordions() {
    const cols = document.querySelectorAll('.mayalice-footer__col');
    if (!cols.length) return;
    const mq = window.matchMedia('(max-width: 780px)');

    const apply = () => {
      const isMobile = mq.matches;
      cols.forEach((col) => {
        if (isMobile) col.removeAttribute('open');
        else col.setAttribute('open', '');
      });
    };

    // Empêcher le toggle natif du <details> sur desktop : le summary n'est
    // cliquable qu'en mobile. Sur desktop, on reste ouvert en permanence.
    cols.forEach((col) => {
      const summary = col.querySelector('summary');
      if (!summary) return;
      summary.addEventListener('click', (e) => {
        if (!mq.matches) e.preventDefault();
      });
    });

    apply();
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', apply);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(apply);
    }
  })();

  // --------------------------------------------------------------------------
  // Instagram · scroll-linked infinite loop
  // Le track bouge uniquement quand l'utilisateur scrolle la page.
  // Scroll down → le track se décale vers la gauche.
  // Scroll up → le track se décale vers la droite.
  // Le modulo sur groupWidth assure un loop seamless (2 groupes dupliqués).
  // --------------------------------------------------------------------------

  document.querySelectorAll('.mayalice-instagram__grid').forEach((grid) => {
    const track = grid.querySelector('.mayalice-instagram__track');
    if (!track || prefersReducedMotion) return;

    const isMobile = window.matchMedia('(max-width: 780px)').matches;
    const factor = isMobile ? 0.8 : 0.45;

    let offset = 0;
    let groupWidth = 0;
    let lastScrollY = window.scrollY;
    let rafId = 0;

    const measure = () => {
      const firstGroup = track.querySelector('.mayalice-instagram__group');
      if (firstGroup) {
        groupWidth = firstGroup.getBoundingClientRect().width;
      }
    };

    const update = () => {
      rafId = 0;
      const currentY = window.scrollY;
      const delta = currentY - lastScrollY;
      lastScrollY = currentY;

      if (delta === 0 || groupWidth === 0) return;

      offset += delta * factor;
      offset = ((offset % groupWidth) + groupWidth) % groupWidth;

      track.style.transform = `translate3d(${-offset}px, 0, 0)`;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!rafId) rafId = requestAnimationFrame(update);
      },
      { passive: true }
    );

    window.addEventListener('resize', () => {
      measure();
    });

    // Initial measure + remesure quand les images sont chargées
    measure();
    const imgs = track.querySelectorAll('img');
    let pending = imgs.length;
    if (pending === 0) measure();
    imgs.forEach((img) => {
      if (img.complete) {
        if (--pending === 0) measure();
      } else {
        img.addEventListener(
          'load',
          () => {
            if (--pending === 0) measure();
          },
          { once: true }
        );
      }
    });
  });

  // --------------------------------------------------------------------------
  // Personnalisation · rotation des prénoms (fade crossfade)
  // --------------------------------------------------------------------------

  document.querySelectorAll('[data-ma-name]').forEach((container) => {
    const items = container.querySelectorAll('[data-ma-name-item]');
    if (items.length < 2) return;
    let i = 0;
    const interval = prefersReducedMotion ? 0 : 2800;
    if (interval === 0) return;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, interval);
  });

  // --------------------------------------------------------------------------
  // Cart drawer · forcer la note fermée à chaque ouverture du drawer
  // --------------------------------------------------------------------------
  (function cartNoteResetOnDrawerOpen() {
    const drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;

    const closeNote = () => {
      document.querySelectorAll('cart-note details[open], .cart-note details[open]').forEach((d) => {
        d.removeAttribute('open');
      });
      document.querySelectorAll('cart-note accordion-custom[open-by-default-on-desktop], cart-note accordion-custom[open-by-default-on-mobile]').forEach((a) => {
        a.removeAttribute('open-by-default-on-desktop');
        a.removeAttribute('open-by-default-on-mobile');
      });
    };

    // À chaque ouverture du drawer (mutation d'attributs), reset la note
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        if (m.attributeName === 'open' && drawer.hasAttribute('open')) {
          closeNote();
        }
      });
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['open'] });

    // Au premier load aussi
    closeNote();
  })();

  // --------------------------------------------------------------------------
  // Quick add · POST /cart/add.js + dispatch cart:update (Atelier drawer ouvre tout seul)
  // Mono-variant → ajout direct + feedback. Multi-variants → redirect vers fiche produit.
  // --------------------------------------------------------------------------

  const CART_ADD_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/') + 'cart/add.js';

  const collectSectionIds = () => {
    const ids = new Set();
    document
      .querySelectorAll('cart-items-component[data-section-id], cart-icon[data-section-id]')
      .forEach((el) => {
        if (el.dataset.sectionId) ids.add(el.dataset.sectionId);
      });
    return Array.from(ids);
  };

  const openCartDrawer = () => {
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.showDialog === 'function') {
      drawer.showDialog();
    } else if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    }
  };

  const CART_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Compteur "visible" du panier : les composants de bundle masqués par
  // cart-products.liquid (_bundle_role ≠ primary dont le primary est présent)
  // ne comptent pas — la bulle du header doit refléter ce que le client voit.
  // Même logique que MAYA.visibleCartCount (dupliquée ici : maya-preview-core.js
  // n'est chargé que sur les pages configurateur).
  const visibleCartCount = (cart) => {
    try {
      const items = (cart && cart.items) || [];
      const withPrimary = new Set();
      items.forEach((it) => {
        const p = it.properties || {};
        if (p._bundle_id && p._bundle_role === 'primary') withPrimary.add(p._bundle_id);
      });
      return items.reduce((n, it) => {
        const p = it.properties || {};
        if (p._bundle_id && p._bundle_role && p._bundle_role !== 'primary' && withPrimary.has(p._bundle_id)) return n;
        return n + (it.quantity || 0);
      }, 0);
    } catch (err) {
      return (cart && cart.item_count) || 0;
    }
  };

  const fetchVisibleCartCount = () =>
    fetch(CART_ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null))
      .then((cart) => (cart ? visibleCartCount(cart) : null))
      .catch(() => null);

  // Toast d'erreur panier : les boutons quick-add sont des icônes, un simple
  // data-state="error" est invisible — il faut un message explicite.
  const showCartError = (msg) => {
    let el = document.querySelector('.ma-cart-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'ma-cart-toast';
      el.setAttribute('role', 'alert');
      document.body.appendChild(el);
    }
    el.textContent = msg || "Impossible d'ajouter cet article au panier.";
    el.classList.add('is-visible');
    window.clearTimeout(showCartError._t);
    showCartError._t = window.setTimeout(() => el.classList.remove('is-visible'), 4000);
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ma-quickadd]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    const variantId = btn.dataset.variantId;
    const variantsCount = parseInt(btn.dataset.variantsCount || '1', 10);
    const productUrl = btn.dataset.productUrl;

    // Multi-variants → go to product page to pick options
    if (variantsCount > 1) {
      if (productUrl) window.location.href = productUrl;
      return;
    }

    if (!variantId) return;
    const state = btn.dataset.state;
    if (state === 'loading' || state === 'added') return;

    btn.dataset.state = 'loading';
    btn.disabled = true;

    const body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');
    collectSectionIds().forEach((id) => body.append('sections', id));

    fetch(CART_ADD_URL, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body,
    })
      .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
      .then(({ ok, data }) => {
        if (!ok || (data.status && data.status !== 200)) {
          throw new Error(data.description || data.message || 'Ajout impossible');
        }

        btn.dataset.state = 'added';

        // cart-icon SET la valeur du badge pour les sources non product-form :
        // il faut le compteur absolu du panier, pas la quantité ajoutée.
        return fetchVisibleCartCount().then((count) => {
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: {},
                sourceId: 'mayalice-quickadd-' + variantId,
                data: {
                  source: 'mayalice-quickadd',
                  itemCount: count != null ? count : 1,
                  variantId: variantId,
                  productId: btn.dataset.productId,
                  sections: data.sections,
                },
              },
            })
          );

          openCartDrawer();

          window.setTimeout(() => {
            btn.dataset.state = '';
            btn.disabled = false;
          }, 1800);
        });
      })
      .catch((err) => {
        console.error('[mayalice] quick add failed', err);
        btn.dataset.state = 'error';
        btn.disabled = false;
        showCartError(err && err.message ? err.message : null);
        window.setTimeout(() => {
          btn.dataset.state = '';
        }, 2500);
      });
  });

  // --------------------------------------------------------------------------
  // Panier · case « sac cadeau » (snippets/cart-products.liquid)
  // Cochée → ajoute le produit sac-cadeau (qté 1) ; décochée → retire sa ligne.
  // Les sections du panier sont re-rendues via cart:update, comme le quick-add.
  // --------------------------------------------------------------------------

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-ma-gift-bag]');
    if (!input) return;
    const wrap = input.closest('[data-ma-gift-bag-wrap]');
    if (wrap) wrap.classList.add('is-loading');

    const adding = input.checked;
    const sections = collectSectionIds();
    const request = adding
      ? fetch(CART_ADD_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(input.dataset.variantId), quantity: 1, sections }),
        })
      : fetch(CART_ROOT + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: input.dataset.lineKey, quantity: 0, sections }),
        });

    request
      .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
      .then(({ ok, data }) => {
        if (!ok || (data.status && data.status !== 200)) {
          throw new Error(data.description || data.message || 'Mise à jour du panier impossible');
        }
        return fetchVisibleCartCount().then((count) => {
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: {},
                sourceId: 'mayalice-gift-bag',
                data: {
                  source: 'mayalice-gift-bag',
                  itemCount: count != null ? count : 0,
                  variantId: input.dataset.variantId,
                  sections: data.sections,
                },
              },
            })
          );
        });
      })
      .catch((err) => {
        console.error('[mayalice] sac cadeau', err);
        input.checked = !adding;
        showCartError(err && err.message ? err.message : null);
      })
      .finally(() => {
        if (wrap) wrap.classList.remove('is-loading');
      });
  });

  // --------------------------------------------------------------------------
  // Configurateurs · hauteur de la barre « Votre composition » fixée en bas,
  // exposée en --ma-cfg-footer-h pour que la bulle « Récompenses » de Trio
  // passe au-dessus du bouton au lieu de le recouvrir (mayalice.css).
  // --------------------------------------------------------------------------

  const cfgFooter = document.querySelector('.cfg-footer');
  if (cfgFooter && 'ResizeObserver' in window) {
    new ResizeObserver(() => {
      document.documentElement.style.setProperty('--ma-cfg-footer-h', cfgFooter.offsetHeight + 'px');
    }).observe(cfgFooter);
  }

  // --------------------------------------------------------------------------
  // Product card · slider horizontal
  // - Sync des dots sur le scroll (snap mandatory côté CSS)
  // - Boutons prev/next desktop : scrollBy d'un slide
  // - État disabled aux extrémités
  // --------------------------------------------------------------------------

  const initCardSlider = (card) => {
    const slider = card.querySelector('[data-ma-card-slider]');
    if (!slider) return;
    const slides = slider.querySelectorAll('[data-ma-card-slide]');
    if (slides.length <= 1) return;

    const dots = card.querySelectorAll('[data-ma-card-dot]');
    const prev = card.querySelector('[data-ma-card-arrow="prev"]');
    const next = card.querySelector('[data-ma-card-arrow="next"]');

    let activeIndex = 0;
    let rafId = 0;

    const setActive = (i) => {
      activeIndex = i;
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
      if (prev) {
        if (i <= 0) prev.setAttribute('data-ma-disabled', '');
        else prev.removeAttribute('data-ma-disabled');
      }
      if (next) {
        if (i >= slides.length - 1) next.setAttribute('data-ma-disabled', '');
        else next.removeAttribute('data-ma-disabled');
      }
    };

    setActive(0);

    slider.addEventListener(
      'scroll',
      () => {
        if (rafId) return;
        rafId = requestAnimationFrame(() => {
          rafId = 0;
          const w = slider.clientWidth;
          if (w === 0) return;
          const i = Math.round(slider.scrollLeft / w);
          if (i !== activeIndex) setActive(Math.max(0, Math.min(slides.length - 1, i)));
        });
      },
      { passive: true }
    );

    const goTo = (i) => {
      const idx = Math.max(0, Math.min(slides.length - 1, i));
      slider.scrollTo({ left: slider.clientWidth * idx, behavior: 'smooth' });
    };

    if (prev) {
      prev.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        goTo(activeIndex - 1);
      });
    }
    if (next) {
      next.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        goTo(activeIndex + 1);
      });
    }

    card.querySelectorAll('[data-ma-card-dot]').forEach((dot, i) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        goTo(i);
      });
    });
  };

  document.querySelectorAll('.mayalice-product-card').forEach(initCardSlider);

  // Re-init après quick-add / remplacement de section (event Atelier)
  document.addEventListener('cart:update', () => {
    document.querySelectorAll('.mayalice-product-card').forEach((card) => {
      if (card.dataset.maSliderReady === '1') return;
      card.dataset.maSliderReady = '1';
      initCardSlider(card);
    });
  });

  // --------------------------------------------------------------------------
  // Image shoppable · sync hotspot ↔ card du panneau
  // Layout 2 colonnes : cliquer un point active sa card à droite (desktop)
  // ou la centre dans le carrousel snap (mobile).
  // --------------------------------------------------------------------------

  document.querySelectorAll('[data-ma-shoppable]').forEach((section) => {
    const pins = Array.from(section.querySelectorAll('[data-ma-shoppable-pin]'));
    const items = Array.from(section.querySelectorAll('[data-ma-shoppable-item]'));
    if (!pins.length && !items.length) return;

    const list = section.querySelector('[data-ma-shoppable-list]');
    const isMobile = () => window.matchMedia('(max-width: 899px)').matches;

    const setActive = (id, opts) => {
      const options = opts || {};
      pins.forEach((p) => p.classList.toggle('is-active', p.dataset.maShoppableId === id));
      items.forEach((it) => it.classList.toggle('is-active', it.dataset.maShoppableId === id));

      if (options.scroll === false) return;

      const target = items.find((it) => it.dataset.maShoppableId === id);
      if (!target || !list) return;

      if (isMobile()) {
        const left = target.offsetLeft - (list.clientWidth - target.clientWidth) / 2;
        list.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      } else {
        const top = target.offsetTop - (list.clientHeight - target.clientHeight) / 2;
        list.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }
    };

    pins.forEach((pin) => {
      const trigger = pin.querySelector('[data-ma-shoppable-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        setActive(pin.dataset.maShoppableId);
      });
    });

    items.forEach((item) => {
      item.addEventListener('mouseenter', () => setActive(item.dataset.maShoppableId, { scroll: false }));
      item.addEventListener('focusin', () => setActive(item.dataset.maShoppableId, { scroll: false }));
    });

    // Sync au scroll horizontal mobile : le pin actif suit la card centrée
    if (list) {
      let rafId = 0;
      list.addEventListener(
        'scroll',
        () => {
          if (!isMobile() || rafId) return;
          rafId = requestAnimationFrame(() => {
            rafId = 0;
            const center = list.scrollLeft + list.clientWidth / 2;
            let closest = items[0];
            let minDist = Infinity;
            items.forEach((it) => {
              const itCenter = it.offsetLeft + it.clientWidth / 2;
              const d = Math.abs(itCenter - center);
              if (d < minDist) {
                minDist = d;
                closest = it;
              }
            });
            if (closest) setActive(closest.dataset.maShoppableId, { scroll: false });
          });
        },
        { passive: true }
      );
    }
  });

  // --------------------------------------------------------------------------
  // Fiche produit Mayalice
  // - Variant picker : matrice options → variant + update price/url/CTA/image
  // - Sticky bar : visible quand le bouton ATC sort du viewport
  // - Form submit : POST /cart/add.js + dispatch cart:update + open drawer
  // - Quantity stepper
  // - Détails ouverture/fermeture animée fluide
  // --------------------------------------------------------------------------

  const formatMoney = (cents) => {
    if (typeof cents !== 'number') return cents;
    const fmt = (window.Shopify && window.Shopify.formatMoney);
    if (typeof fmt === 'function') {
      try {
        return fmt(cents, (window.Shopify.money_format || '€{{amount}}'));
      } catch (e) { /* fallback */ }
    }
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR' });
  };

  document.querySelectorAll('[data-ma-product]').forEach((root) => {
    const form = root.querySelector('[data-ma-product-form]');
    if (!form) return;

    const variantsScript = root.querySelector('script[data-ma-product-variants]');
    let variants = [];
    try {
      variants = JSON.parse(variantsScript ? variantsScript.textContent : '[]');
    } catch (e) {
      console.warn('[mayalice] cannot parse variants', e);
    }

    const variantInput = form.querySelector('[data-ma-product-variant-id]');
    const submitBtn = form.querySelector('[data-ma-product-submit]');
    const submitDefault = form.querySelector('[data-ma-product-submit-state="default"]');
    const priceEl = root.querySelector('[data-ma-product-price]');
    const optionInputs = Array.from(form.querySelectorAll('[data-ma-product-option-input]'));
    const optionSelectedLabels = root.querySelectorAll('[data-ma-product-option-value]');
    const gallery = root.querySelector('[data-ma-product-gallery]');
    const slider = gallery ? gallery.querySelector('[data-ma-product-slider]') : null;
    const slides = slider ? Array.from(slider.querySelectorAll('[data-ma-product-slide]')) : [];
    const thumbs = gallery ? Array.from(gallery.querySelectorAll('[data-ma-product-thumb]')) : [];
    const dots = gallery ? Array.from(gallery.querySelectorAll('[data-ma-product-dot]')) : [];
    const arrowPrev = gallery ? gallery.querySelector('[data-ma-product-arrow="prev"]') : null;
    const arrowNext = gallery ? gallery.querySelector('[data-ma-product-arrow="next"]') : null;
    const counterIndex = gallery ? gallery.querySelector('[data-ma-product-counter-index]') : null;
    const bar = root.querySelector('[data-ma-product-bar]');
    const barPrice = root.querySelector('[data-ma-product-bar-price]');
    const barBtn = root.querySelector('[data-ma-product-bar-submit]');

    // ----- Galerie : sync slider <-> thumbs/dots/arrows/counter -----
    let activeSlide = 0;
    const setActiveSlide = (i) => {
      activeSlide = Math.max(0, Math.min(slides.length - 1, i));
      thumbs.forEach((t, idx) => t.classList.toggle('is-active', idx === activeSlide));
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx === activeSlide));
      if (counterIndex) {
        counterIndex.textContent = String(activeSlide + 1).padStart(2, '0');
      }
      if (arrowPrev) {
        if (activeSlide <= 0) arrowPrev.setAttribute('data-ma-disabled', '');
        else arrowPrev.removeAttribute('data-ma-disabled');
      }
      if (arrowNext) {
        if (activeSlide >= slides.length - 1) arrowNext.setAttribute('data-ma-disabled', '');
        else arrowNext.removeAttribute('data-ma-disabled');
      }
    };

    const goToSlide = (i) => {
      if (!slider) return;
      const idx = Math.max(0, Math.min(slides.length - 1, i));
      slider.scrollTo({ left: slider.clientWidth * idx, behavior: 'smooth' });
    };

    if (slider) {
      let rafId = 0;
      slider.addEventListener('scroll', () => {
        if (rafId) return;
        rafId = requestAnimationFrame(() => {
          rafId = 0;
          const w = slider.clientWidth;
          if (!w) return;
          const i = Math.round(slider.scrollLeft / w);
          if (i !== activeSlide) setActiveSlide(i);
        });
      }, { passive: true });
    }

    thumbs.forEach((t) => {
      t.addEventListener('click', () => {
        const i = parseInt(t.dataset.maProductThumb, 10);
        goToSlide(i);
      });
    });

    dots.forEach((d) => {
      d.addEventListener('click', () => {
        const i = parseInt(d.dataset.maProductDot, 10);
        goToSlide(i);
      });
    });

    if (arrowPrev) arrowPrev.addEventListener('click', () => goToSlide(activeSlide - 1));
    if (arrowNext) arrowNext.addEventListener('click', () => goToSlide(activeSlide + 1));

    if (slides.length) setActiveSlide(0);

    const buildPriceHtml = (variant) => {
      const compare = variant.compare_at_price;
      const price = variant.price;
      const html = [];
      html.push(`<span class="mayalice-product__price-current">${formatMoney(price)}</span>`);
      if (compare && compare > price) {
        html.push(`<del class="mayalice-product__price-was">${formatMoney(compare)}</del>`);
        html.push(`<span class="mayalice-product__price-save">— ${formatMoney(compare - price)}</span>`);
      }
      return html.join(' ');
    };

    const getSelectedOptions = () => {
      const selected = [];
      optionInputs.forEach((input) => {
        if (input.checked) selected.push(input.value);
      });
      return selected;
    };

    const findVariant = (selected) => {
      return variants.find((v) => {
        return v.options.every((opt, i) => opt === selected[i]);
      });
    };

    // Marque les variantes en rupture (cosmétique)
    const refreshAvailability = () => {
      const selected = getSelectedOptions();
      // Pour chaque option, vérifie quelles valeurs sont disponibles avec le reste figé
      optionInputs.forEach((input) => {
        const fieldset = input.closest('[data-ma-product-option-index]');
        if (!fieldset) return;
        const optIndex = parseInt(fieldset.dataset.maProductOptionIndex, 10);
        const probe = selected.slice();
        probe[optIndex] = input.value;
        const match = variants.find((v) => v.options.every((opt, i) => opt === probe[i]));
        const label = input.nextElementSibling;
        if (label) {
          if (!match || !match.available) label.setAttribute('data-ma-unavailable', '');
          else label.removeAttribute('data-ma-unavailable');
        }
      });
    };

    const updateUrl = (variantId) => {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* noop */ }
    };

    const scrollGalleryToMedia = (mediaId) => {
      if (!slider || !mediaId) return;
      const idx = slides.findIndex((s) => s.dataset.mediaId == mediaId);
      if (idx < 0) return;
      goToSlide(idx);
    };

    const renderVariant = (variant, opts) => {
      const options = opts || {};
      // Variant ID
      if (variantInput) variantInput.value = variant.id;
      // Prix
      if (priceEl) priceEl.innerHTML = buildPriceHtml(variant);
      if (barPrice) barPrice.textContent = formatMoney(variant.price);
      // CTA disponibilité
      if (submitBtn) {
        if (variant.available) {
          submitBtn.disabled = false;
          if (submitDefault) submitDefault.textContent = 'Ajouter au panier';
        } else {
          submitBtn.disabled = true;
          if (submitDefault) submitDefault.textContent = 'Indisponible';
        }
      }
      // URL
      if (!options.silent) updateUrl(variant.id);
      // Image associée si présente
      if (!options.silent && variant.featured_media && variant.featured_media.id) {
        scrollGalleryToMedia(variant.featured_media.id);
      }
      // Étiquettes "selected_value"
      optionSelectedLabels.forEach((el) => {
        const idx = parseInt(el.dataset.maProductOptionValue, 10);
        if (variant.options[idx] != null) el.textContent = variant.options[idx];
      });
    };

    const handleOptionChange = () => {
      const selected = getSelectedOptions();
      const variant = findVariant(selected);
      refreshAvailability();
      if (!variant) {
        if (submitBtn) {
          submitBtn.disabled = true;
          if (submitDefault) submitDefault.textContent = 'Indisponible';
        }
        return;
      }
      renderVariant(variant);
    };

    optionInputs.forEach((input) => input.addEventListener('change', handleOptionChange));

    // Init availability
    refreshAvailability();

    // Quantity stepper
    const qtyInput = form.querySelector('[data-ma-product-qty-input]');
    form.querySelectorAll('[data-ma-product-qty-step]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!qtyInput) return;
        const step = parseInt(btn.dataset.maProductQtyStep, 10);
        const next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step);
        qtyInput.value = next;
      });
    });

    // Form submit · POST /cart/add.js
    const submitForm = (triggeringBtn) => {
      const variantId = variantInput && variantInput.value;
      const qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      if (!variantId) return;
      const btn = triggeringBtn || submitBtn;
      if (!btn) return;
      const state = btn.dataset.state;
      if (state === 'loading' || state === 'added') return;
      btn.dataset.state = 'loading';
      btn.disabled = true;
      if (submitBtn && submitBtn !== btn) {
        submitBtn.dataset.state = 'loading';
        submitBtn.disabled = true;
      }

      const sectionIds = (() => {
        const ids = new Set();
        document.querySelectorAll('cart-items-component[data-section-id], cart-icon[data-section-id]').forEach((el) => {
          if (el.dataset.sectionId) ids.add(el.dataset.sectionId);
        });
        return Array.from(ids);
      })();

      const body = new FormData();
      body.append('id', variantId);
      body.append('quantity', String(qty));
      sectionIds.forEach((id) => body.append('sections', id));

      const cartAddUrl = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js';

      fetch(cartAddUrl, { method: 'POST', headers: { Accept: 'application/json' }, body })
        .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
        .then(({ ok, data }) => {
          if (!ok || (data.status && data.status !== 200)) {
            throw new Error(data.description || data.message || 'Ajout impossible');
          }
          [submitBtn, triggeringBtn].forEach((b) => {
            if (!b) return;
            b.dataset.state = 'added';
            b.disabled = false;
          });
          // cart-icon SET la valeur du badge pour les sources non product-form :
          // il faut le compteur absolu du panier, pas la quantité ajoutée.
          return fetchVisibleCartCount().then((count) => {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: {},
                sourceId: 'mayalice-product-' + variantId,
                data: {
                  source: 'mayalice-product',
                  itemCount: count != null ? count : qty,
                  variantId,
                  productId: root.dataset.productId,
                  sections: data.sections,
                },
              },
            }));
            const drawer = document.querySelector('cart-drawer-component');
            if (drawer && typeof drawer.showDialog === 'function') drawer.showDialog();
            else if (drawer && typeof drawer.open === 'function') drawer.open();

            window.setTimeout(() => {
              [submitBtn, triggeringBtn].forEach((b) => {
                if (!b) return;
                b.dataset.state = '';
                b.disabled = false;
              });
            }, 2000);
          });
        })
        .catch((err) => {
          console.error('[mayalice] add to cart failed', err);
          showCartError(err && err.message ? err.message : null);
          [submitBtn, triggeringBtn].forEach((b) => {
            if (!b) return;
            b.dataset.state = 'error';
            b.disabled = false;
            window.setTimeout(() => { b.dataset.state = ''; }, 2200);
          });
        });
    };

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      submitForm(submitBtn);
    });

    if (barBtn) {
      barBtn.addEventListener('click', () => submitForm(barBtn));
    }

    // Sticky bar : visible quand le bouton ATC principal n'est plus visible
    if (bar && submitBtn && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            bar.setAttribute('hidden', '');
          } else if (entry.boundingClientRect.top < 0) {
            // Le CTA est sorti par le HAUT du viewport — on affiche la bar
            bar.removeAttribute('hidden');
          } else {
            bar.setAttribute('hidden', '');
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
      io.observe(submitBtn);
    }

    // Initial : si l'URL contient ?variant=, on synchronise
    try {
      const params = new URLSearchParams(window.location.search);
      const variantParam = params.get('variant');
      if (variantParam) {
        const variant = variants.find((v) => String(v.id) === variantParam);
        if (variant) {
          // Coche les bons radios
          variant.options.forEach((value, optIdx) => {
            const fs = form.querySelector(`[data-ma-product-option-index="${optIdx}"]`);
            if (!fs) return;
            const input = fs.querySelector(`[data-ma-product-option-input][value="${value.replace(/"/g, '\\"')}"]`);
            if (input) input.checked = true;
          });
          renderVariant(variant, { silent: true });
        }
      }
    } catch (e) { /* noop */ }
  });

  // --------------------------------------------------------------------------
  // Cart bundle · cascade delete
  // Quand on supprime la ligne principale d'un bundle (data-bundle-role="primary",
  // ou "parent" pour l'ancien format v3), on supprime aussi tous ses composants
  // via un seul POST /cart/update.js atomique avec updates: { KEY: 0, ... }.
  // Les lignes composants sont MASQUÉES du DOM par cart-products.liquid :
  // la composition du bundle ne peut venir que de /cart.js, pas du DOM.
  // Écouteur sur WINDOW en capture : le dispatcher `on:click` de Horizon
  // (component.js) écoute document en capture ; sur le même nœud,
  // stopPropagation ne l'arrête pas → sa suppression native de la seule ligne
  // primary partait en parallèle, gagnait la course, et notre /cart/update.js
  // tombait en 422 (clé disparue) → lettres/charms orphelins au panier.
  // --------------------------------------------------------------------------

  window.addEventListener('click', async (e) => {
    const removeBtn = e.target.closest('[data-action="remove"], cart-remove-button, .cart-items__remove');
    if (!removeBtn) return;
    const row = removeBtn.closest('[data-bundle-id]');
    if (!row) return; // Pas un item bundle, comportement natif
    const role = row.getAttribute('data-bundle-role');
    if (role !== 'primary' && role !== 'parent') return; // Composants : supprimés via leur primary

    const bundleId = row.getAttribute('data-bundle-id');
    if (!bundleId) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    removeBtn.disabled = true;

    try {
      const cartRes = await fetch(CART_ROOT + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!cartRes.ok) throw new Error('HTTP ' + cartRes.status);
      const cart = await cartRes.json();

      // /cart/update.js accepte les line_items par key → gère les variants en
      // doublon entre plusieurs bundles (deux colliers avec la même lettre).
      const updates = {};
      (cart.items || []).forEach((it) => {
        const p = it.properties || {};
        if (p._bundle_id === bundleId) updates[it.key] = 0;
      });
      if (!Object.keys(updates).length) {
        const key = row.getAttribute('data-key');
        if (key) updates[key] = 0;
      }
      if (!Object.keys(updates).length) throw new Error('bundle introuvable dans /cart.js');

      const sectionIds = (() => {
        const ids = new Set();
        document.querySelectorAll('cart-items-component[data-section-id], cart-icon[data-section-id], cart-drawer-component[data-section-id]')
          .forEach((el) => { if (el.dataset.sectionId) ids.add(el.dataset.sectionId); });
        return Array.from(ids);
      })();
      const res = await fetch(CART_ROOT + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates, sections: sectionIds }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || `HTTP ${res.status}`);
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: data,
          sourceId: 'mayalice-bundle-remove-' + bundleId,
          data: {
            source: 'mayalice-bundle-remove',
            bundleId,
            itemCount: visibleCartCount(data),
            sections: data.sections,
          },
        },
      }));
    } catch (err) {
      console.error('[mayalice] bundle remove failed', err);
      showCartError('La suppression a échoué. Recharge la page et réessaie.');
      removeBtn.disabled = false;
    }
  }, true);
})();
